module.exports = __webpack_public_path__ + "static/media/Litleo_gaussian2.849e4b0b.png";